"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLOZE_REGEX = void 0;
exports.CLOZE_REGEX = {
    ANKI_CAPTURE_CONTENT_AND_NUM: /{{c(\d)::(.*?)}}/g,
    CAPTURE_CONTENT: /{card\d:(.*?)}/g,
    CAPTURE_NUM: /{card(\d):.*?}/g,
    EXACT_MATCH: /^{card\d:.*?}$/,
};
